import { render } from "react-dom";
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import classNames from "classnames";
import uuid from 'react-uuid';
import $ from 'jquery';

const AccordionItem = ({ title, content, uuidKey, headingType }) => {
  const [_uuid, setUuid] = useState<string>('');

  useEffect(() => {
    if (_uuid !== '') {
      const target = $(`.accordian-item-${uuidKey}`);

      if (!$(`.accordian-item-${uuidKey}`).hasClass('isopen')) {
        Array.from(document.getElementsByClassName(`accordion-item`)).forEach(el => el.classList.remove('isopen'));
        target.addClass('isopen')
      } else {
        target.removeClass('isopen')
      }
    }
  }, [_uuid])


  const toggleOpen = () => {
    setUuid(uuid())
  };

  return (
    <div id="accordion-item" className={classNames("accordion-item", `accordian-item-${uuidKey}`)}>
      <div className="accordion-header" onClick={toggleOpen}>
        <span>
          <motion.hr />
          <motion.hr />
        </span>
        {headingType === 'H4' ?
          <h4>{title}</h4>
          :
          <h3>{title}</h3>
        }
      </div>

      <div
        className="accordion-content"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
};

export const useAccordionWrapper = () => {
  // Extract the title text, and content HTML from the known HTML structure of an accordion item
  const getTitleAndContent = (item) => {
    const title =
      item.querySelector(".accordion-header")?.querySelector("h3, h4")?.innerText ||
      null;
    const headingType = item.querySelector(".accordion-header")?.querySelector("h3, h4")?.tagName;
    const content = item.querySelector(".accordion-content")?.innerHTML || null;

    return { title, content, headingType };
  };

  useEffect(() => {
    const accordions = Array.from(
      document.querySelectorAll(".accordion-wrapper")
    );

    // loop through each accordion on the page
    accordions.forEach((acc) => {
      // and find the items within that accordion
      const accordionItems = Array.from(
        acc.querySelectorAll(".accordion-item")
      );

      // and now replace the accordion with the AccordionItem component
      accordionItems.forEach((item) => {
        const { title, content } = getTitleAndContent(item);
        if (title && content) {
          item.classList.remove("accordion-item");
          return render(<AccordionItem {...getTitleAndContent(item)} uuidKey={uuid()} />, item);
        }
      });
    });
  }, []);
};

export const useOldAccordionWrapper = () => {
  // Extract the title text, and content HTML from the known HTML structure of an accordion item
  const getTitleAndContent = (item) => {
    const title =
      item.querySelector(".accordion-header")?.querySelector("h4, h3, h2, h1")?.innerText ||
      null;
    const headingType = item.querySelector(".accordion-header")?.querySelector("h3, h4")?.tagName;
    const content =
      item.querySelector(".transcript article")?.innerHTML || null;

    return { title, content, headingType };
  };

  useEffect(() => {
    const accordions = Array.from(document.querySelectorAll(".accordion"));

    // loop through each accordion on the page
    accordions.forEach((item) => {
      const { title, content, headingType } = getTitleAndContent(item);
      if (title && content && headingType) {
        return render(<AccordionItem {...getTitleAndContent(item)} uuidKey={uuid()} />, item);
      }
    });
  }, []);
};
